import React from "react";
import { AppContext, setSelectedAnncmnt } from "../context";
import { Modal } from "antd";

export const AppAnnouncementModal: React.FC = () => {
    const { dispatch, state } = React.useContext(AppContext);
    const [mWidth, setMWidth] = React.useState<number>();
    const { selectedAnncmnt } = state;

    React.useEffect(() => {
        if (document.body.clientWidth > 768) {
            setMWidth(768);
        } else setMWidth(undefined);
    }, [selectedAnncmnt]);

    return (
        <Modal
            title={<AnnouncementTitle banner={selectedAnncmnt?.Banner} title={selectedAnncmnt?.Title} />}
            className={`ss-dashboard-wrap-anncmnt-modal${!selectedAnncmnt?.Banner && " no-banner"}`}
            centered
            width={mWidth}
            open={selectedAnncmnt !== undefined}
            onOk={() => dispatch(setSelectedAnncmnt(undefined))}
            onCancel={() => dispatch(setSelectedAnncmnt(undefined))}
            cancelButtonProps={{ style: { display: "none" } }}>
            <p>{selectedAnncmnt?.Message}</p>
            <p className="announcement-image-links text-center">
                {selectedAnncmnt?.ImageLinks &&
                    selectedAnncmnt?.ImageLinks.map((img) => (
                        <a href={img.Url} title={img.Label} target="_blank" rel="noreferrer">
                            <img src={img.Image} alt={img.AltText} />
                        </a>
                    ))}
            </p>
            <p>{selectedAnncmnt?.FooterNote}</p>
        </Modal>
    );
};

const AnnouncementTitle: React.FC<{ banner?: string; title?: string }> = ({ title, banner }) => {
    const style: React.CSSProperties | undefined = banner
        ? {
              backgroundImage: `url(${banner})`,
              height: 100,
          }
        : {
              color: "#344356",
          };
    return (
        <div className="announcement-title" {...{ style }}>
            <h3>{title}</h3>
        </div>
    );
};
